import request from '../api/request'

//ai提问
export function aiChat(params) {
  return request({
    baseURL:'https://api.dtgh91.com/',
    url: 'ai/chat',
    method: 'get',
    params
  })
}
//ai轮询
export function getChatRetrieve(params) {
  return request({
    baseURL:'https://api.dtgh91.com/',
    url: 'ai/getChatRetrieve',
    method: 'get',
    params
  })
}
//ai提问完获取消息
export function getChatMessageList(params) {
  return request({
    baseURL:'https://api.dtgh91.com/',
    url: 'ai/getChatMessageList',
    method: 'get',
    params
  })
}
//获取推荐医生
export function getAiDoctorList(params) {
  return request({
    baseURL:'https://api.dtgh91.com/',
    url: 'ai/getAiDoctorList',
    method: 'get',
    params
  })
}